import { render } from "./TableBlock.vue?vue&type=template&id=080a7208&scoped=true"
import script from "./TableBlock.vue?vue&type=script&lang=js"
export * from "./TableBlock.vue?vue&type=script&lang=js"

import "./TableBlock.vue?vue&type=style&index=0&id=080a7208&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080a7208"]])

export default __exports__